<template>
  <div class="pay_cont apayaccount target_apayaccount">
    <div class="row card-method">
      <div id="paymentPanel01">
        <div class="swiper mySwiper card-swiper type-gray">
          <div class="swiper-wrapper" v-if="haveAccount">
            <Flicking
              :key="selectedParty"
              ref="accountFlicking"
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @changed="onSlideChange"
              @select="onSlideSelect"
              @ready="onSwiperReady"
            >
              <account-slider
                v-for="(account, index) in accounts"
                :key="index"
                :class="index === activeIndex ? 'swiper-slide-active' : ''"
                :account="account"
              />

              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>

          <div class="swiper-wrapper" v-else>
            <Flicking
              :key="selectedParty"
              ref="accountFlicking"
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @ready="onSwiperReady"
            >
              <div
                class="swiper-slide"
                style="width: 302px !important; padding: 0 8px"
              >
                <div class="payment-unit">
                  <a class="payment-link">
                    <div class="payment-card card-area">
                      <p>
                        등록된 A Pay 계좌/카드가 없습니다.<br />
                        암웨이 홈페이지에서 등록 후 사용해주세요.
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AccountSlider from "@/views/order/main/components/Payment/AccountSlider";
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
import { log } from "@/utils/common";
import { mapGetters } from "vuex";
import { AMWAY_PAY_METHODS } from "@/utils/constants";
export default {
  name: "AmwayPayAccount",
  components: {
    AccountSlider,
    Flicking,
  },
  props: {
    amwayPayAccounts: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      plugins: [
        new Arrow({
          prevElSelector: ".swiper-button-prev",
          nextElSelector: ".swiper-button-next",
        }),
      ],
      activeIndex: 0,
      swiperOptions: {
        align: "center",
        circular: false,
        panelsPerView: -1,
        noPanelStyleOverride: false,
      },
    };
  },
  mounted() {
    // if(!this.haveAccount) {
    //   console.log("reset account");
    //   this.$store.commit('amwaypay/resetAmwayPay');
    // }

    const paymentInfo = this.paymentInfo;
    const paymentMode = paymentInfo.paymentMode;
    const paymentCode = paymentInfo.paymentCode;

    console.log("mounted AmwayPayAccount");

    if (paymentMode == AMWAY_PAY_METHODS.ACCOUNT) {
      if (!!paymentCode) {
        let index = -1;
        index = this.amwayPayAccounts.masterParty.findIndex(
          (account) => account.methodKey == paymentCode
        );
        if (index > -1) {
          this.activeIndex = index;
          this.$store.commit("amwaypay/updateSelectedParty", 0);
          return;
        }

        index = this.amwayPayAccounts.subParty.findIndex(
          (account) => account.methodKey == paymentCode
        );

        if (index > -1) {
          this.activeIndex = index;
          this.$store.commit("amwaypay/updateSelectedParty", 1);
          return;
        }

        // if (index == -1) {
        //   this.$store.commit("amwaypay/resetAmwayPay");
        // }
      }
    }
  },
  computed: {
    ...mapGetters({
      paymentInfo: "payment/paymentInfo",
      selectedParty: "amwaypay/selectedParty",
    }),
    accounts() {
      return this.selectedParty === 0
        ? this.amwayPayAccounts.masterParty
        : this.amwayPayAccounts.subParty;
    },
    haveAccount() {
      return this.accounts.length > 0;
    },
  },
  methods: {
    onSlideChange(data) {
      console.log("Account onSlideChange : ", data);
      this.activeIndex = data.index;
      this.chooseAccount(this.activeIndex);
    },
    onSlideSelect(data) {
      console.log("Account onSlideSelect : ", data);
      this.activeIndex = data.index;
      data.panel.focus(300);
      this.chooseAccount(this.activeIndex);
    },
    onSwiperReady(event) {
      console.log("Account onSwiperReady : ", event);
      this.$refs.accountFlicking.moveTo(this.activeIndex);
      this.chooseAccount(this.activeIndex);

      // this.chooseAccount(event.currentTarget.currentPanel.index);
    },
    chooseAccount(index) {
      console.log("chooseAccount : ", index);
      const selectedAccount = this.accounts[index];
      this.$store.commit("amwaypay/selectAmwayPayAccount", selectedAccount);
      log("chooseAccount:: ", selectedAccount);
    },
  },
};
</script>

<style scoped>
</style>
